module.exports = "<app-subheader></app-subheader>\n<app-services-description></app-services-description>\n<app-footer></app-footer>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/services/services.component.html
// module id = ../../../../../src/app/services/services.component.html
// module chunks = 0